__turbopack_context__.v({
  "closeBtn": "index-module__CE8V2a__closeBtn",
  "icon": "index-module__CE8V2a__icon",
  "large": "index-module__CE8V2a__large",
  "medium": "index-module__CE8V2a__medium",
  "modal": "index-module__CE8V2a__modal",
});
